import ApiService, { api } from "src/util/api.service";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface LoginPayload {
  email: string;
  password: string;
  otp?: string;
  sessionId?: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  user?: unknown;
  requiresOtp?: boolean;
  sessionId?: string | null;
}

export const login = async (payload: LoginPayload) => {
  return api.post<LoginResponse>(ServicesUrlEndpoints.AUTH.LOGIN, payload);
};

export interface SessionTokenResponse {
  response: {
    token: { access_token: string; refresh_token: string };
    role: string;
    details: unknown;
  };
}

export const sessionToken = async ({ token }: { token: string }) => {
  return ApiService.get<SessionTokenResponse>(
    `${ServicesUrlEndpoints.AUTH.SESSION_TOKEN}/${token}`
  );
};

export const resetPasswordAfterLogin = async (payload: Record<string, unknown>) => {
  return ApiService.post(ServicesUrlEndpoints.AUTH.RESET_PASSWORD, payload);
};

export const generateForgotPassword = async (payload: Record<string, unknown>) => {
  return ApiService.post(ServicesUrlEndpoints.AUTH.FORGOT_PASSWORD_GENERATE, {}, {
    params: { ...payload, platform: "CRM" },
  });
};

export const resetPassword = async (payload: Record<string, unknown>) => {
  return ApiService.post(ServicesUrlEndpoints.AUTH.FORGOT_PASSWORD_RESET, payload);
};

export const verifyResetToken = async (params: Record<string, string>) => {
  return ApiService.get(ServicesUrlEndpoints.AUTH.VERIFY_TOKEN, { params });
};
